import { render, staticRenderFns } from "./TemperatureChart.vue?vue&type=template&id=08fb87f5&scoped=true&"
import script from "./TemperatureChart.vue?vue&type=script&lang=js&"
export * from "./TemperatureChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb87f5",
  null
  
)

export default component.exports